import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin-bottom: 35px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;

  position: relative;

  & > button {
    position: absolute;
    right: 13px;
    background: transparent;
  }
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
`;
